import { render } from "./AladariPages.vue?vue&type=template&id=ef8d8f0a&scoped=true"
import script from "./AladariPages.vue?vue&type=script&lang=js"
export * from "./AladariPages.vue?vue&type=script&lang=js"

import "./AladariPages.vue?vue&type=style&index=0&id=ef8d8f0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef8d8f0a"]])

export default __exports__